<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<el-card shadow="hover">
					<div slot="header" class="px-2">
						<h5 class="text-center m-0 px-2">Top 10 Product (This Month)</h5>
					</div>
					<div class="list-item-container px-2">
						<div class="list-item2" v-for="(item, index) in reportdata.data" :key="item.ProductId">
							<div class="list-item-label text-left" style="width:40px;"> {{ ++index }} </div>
							<div class="list-item-label text-left pr-1"> {{ item.ProductName }} </div>
							<div class="text-right font-weight-bold"> {{ formatNum(item.TransactionCount, 0) }}</div>
						</div>
					</div>
					<Loader v-if="loading.table" />
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data() {
		return {
			reportdata: [],
            value: 0,
			loading: {
				table: false,
				chart: false,
			},
		}
	},
	watch: {

	}, 
	computed: {

	},

    mounted() {
		this.getData();
    },
    methods:{
		async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/brightpaymentpoint/toptenmonthly?'

			/*
            this.urlRequestParams += '&plant='+this.plant
			this.urlRequestParams += '&station='+this.stationid
			this.urlRequestParams += '&type='+this.stationtype
			this.urlRequestParams += '&area='+this.area
			this.urlRequestParams += '&owner='+this.owner
			this.urlRequestParams += '&lokasi='+this.lokasi
			this.urlRequestParams += '&category='+this.category
			this.urlRequestParams += '&subcategory='+this.subcategory
			this.urlRequestParams += '&status='+this.status
			*/

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
	}
}
</script>


<style>
.list-item-container {
    width: 100%;
    margin: 0 auto;
}

.list-item2 {
	display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.list-item-label {
	width: 100%;
	text-align: left;
	font-weight: normal;
}
  </style>